import { isErgoIntern, isExtern } from './Is';

export const RBArules = {
  administrateur: {
    static: [
      'dashboard:visit',
      'delete',
      'pre-folder:edit',
      'folder:edit',
      'tasks:read',
      'beneficiaries:read',
      'folder:read',
      'report:read',
      'comments:create',
      'comments:read',
      'comments:read:sensitive',
      'comments:edit',
      'comments:delete',
      'comments:create:sensitive',
      'companies:read',
      'companies:create',
      'companies:update',
      'companies:update_all_fields',
      'companies:edit_priority_access',
      'companies:edit_qualifications',
      'ergo-offices:read',
      'ergo-offices:create',
      'expected-quotes:read',
      'quotes:read',
      'self:edit',
      'data:medical:read',
      'project-place-work:read',
      'project-place-ergo:read',
      'ergo-resources:read',
      'ergo-resources:edit',
      'sectors:read',
      'invoices:read',
      'invoices:control_invoice',
      'invoices:delete_invoice',
      'invoices:cancel_validation',
      'users:read',
      'users:edit_project_place_access',
      'users:manage_invitations',
      'quality-control-summaries:read',
      'tasks:operator:read',
      'tasks:delete_task',
      'folder:bloc_f:quote_auto_followup:edit',
    ],
  },
  'pilote externe': {
    static: [
      'pre-folder:edit',
      'folder:bloc:read',
      'folder:bloc_0:read',
      'folder:bloc_c:read',
      'folder:bloc_a:read',
      'folder:bloc_d:read',
      'folder:bloc_e:read',
      'folder:bloc_f:read',
      'folder:bloc_g:read',
      'folder:bloc_h:read',
      'folder:bloc_i:read',
      'comments:create',
      'comments:read',
      'comments:read:sensitive',
      'report:read',
    ],
  },
  'référent externe': {
    static: [
      'pre-folder:edit',
      'folder:bloc:read',
      'folder:bloc_0:read',
      'folder:bloc_c:read',
      'folder:bloc_a:read',
      'folder:bloc_d:read',
      'folder:bloc_e:read',
      'folder:bloc_f:read',
      'folder:bloc_g:read',
      'folder:bloc_h:read',
      'folder:bloc_i:read',
    ],
  },
  ergothérapeute: {
    static: [
      'project-place-ergo:read',
      'project-place-ergo:position',
      'folder:edit',
      'ergo-resources:read',
      'invoices:read',
      'self:edit',
      'tasks:operator:read',
    ],
    dynamic: {
      'quality-control-summaries:read': isErgoIntern,
      'users:read': isErgoIntern,
      'project-place-work:read': isErgoIntern,
      'data:medical:read': isErgoIntern,
      'expected-quotes:read': isErgoIntern,
      'quotes:read': isErgoIntern,
      'comments:create': isErgoIntern,
      'comments:read': isErgoIntern,
      'comments:read:sensitive': isErgoIntern,
      'comments:edit': isErgoIntern,
      'comments:delete': isErgoIntern,
      'comments:create:sensitive': isErgoIntern,
      'companies:read': isErgoIntern,
      'companies:create': isErgoIntern,
      'companies:update': isErgoIntern,
      'companies:update_all_fields': isErgoIntern,
      'ergo-offices:read': isErgoIntern,
      'ergo-offices:create': isErgoIntern,
      'folder:read': isErgoIntern,
      'tasks:read': isErgoIntern,
      'beneficiaries:read': isErgoIntern,
      'folder:bloc:read': isExtern,
      'folder:bloc_a:read': isExtern,
      'folder:bloc_f:read': isExtern,
      'folder:bloc_h:read': isExtern,
      'invoices:control_invoice': isErgoIntern,
      'invoices:cancel_validation': isErgoIntern,
    },
    exclude: {
      'folder:bloc_a:tab_1:type_of_visit:read': isExtern,
      'folder:bloc_a:tab_1:company_name:read': isExtern,
      'folder:bloc_a:tab_1:operators:read': isExtern,
      'folder:bloc_a:tab_1:visit_preparation:visit_reminder_sent_at:read': isExtern,
      'folder:bloc_a:tab_3:sent_2dpe_at:read': isExtern,
      'folder:bloc_f:tab_summary:read': isExtern,
      'folder:bloc_h:tab_1:form_section_1:read': isExtern,
      'invoices:control_invoice': isExtern,
      'invoices:cancel_validation': isExtern,
    },
  },
  'conseiller social': {
    static: [
      'folder:edit',
      'folder:read',
      'tasks:read',
      'beneficiaries:read',
      'comments:create',
      'comments:read',
      'comments:read:sensitive',
      'comments:edit',
      'comments:delete',
      'comments:create:sensitive',
      'companies:read',
      'companies:create',
      'companies:update',
      'companies:update_all_fields',
      'ergo-offices:read',
      'ergo-offices:create',
      'self:edit',
      'data:medical:read',
      'project-place-work:read',
      'project-place-ergo:read',
      'expected-quotes:read',
      'quotes:read',
      'tasks:operator:read',
    ],
  },
  'coordinateur entreprises': {
    static: [
      'folder:bloc:read',
      'folder:bloc_e:read',
      'folder:bloc_f:read',
      'folder:bloc_g:read',
      'folder:bloc_h:read',
      'folder:bloc_i:read',
      'companies:read',
      'companies:create',
      'companies:edit_qualifications',
      'comments:read',
      'project-place:position',
      'companies:update',
      'companies:update_all_fields',
      'users:read',
      'users:edit_project_place_access',
      'users:manage_invitations',
      'expected-quotes:read',
      'quotes:read',
      'project-place-work:read',
    ],
  },
  'référent entreprise': {
    static: [
      'quotes:read',
      'expected-quotes:read',
      'project-place:position',
      'comments:read',
      'companies:read',
      'companies:create',
      'companies:update',
      'companies:edit_qualifications',
    ],
    dynamic: {
      'project-place-work:read': data => data?.user?.hasAccessToProjectPlace === true,
    },
    exclude: ['comments:create', 'comments:read:sensitive'],
  },
};
